import { fromCallback } from 'xstate';

import { LockLease, acquireLease } from '@eluve/navigator-utils';

import { FileLockEvents } from '../../types';

export const lockManagerActor = fromCallback<FileLockEvents, { id?: string }>(
  ({ input: { id }, sendBack }) => {
    let lockResult: LockLease | null = null;

    if (id) {
      acquireLease(id)
        .then((result) => {
          if (typeof result?.release === 'function') {
            lockResult = result;
            sendBack({
              type: 'LOCK_ACQUIRED',
              id,
            });
          } else {
            sendBack({
              type: 'LOCK_FAILED',
              id,
            });
          }
        })
        .catch(() => {
          sendBack({
            type: 'LOCK_FAILED',
            id,
          });
        });
    } else {
      sendBack({
        type: 'LOCK_FAILED',
        id,
      });
    }

    return () => {
      lockResult?.release();
    };
  },
);
